import { useEffect, useState } from "react";
import { publicApi } from "../lib/api";
import { useLenis } from "../lib/useLenis";
import { DEFAULT_SITE_DATA } from "../constants/defaultSiteData";
import SEO from "../components/site/SEO";
import Navbar from "../components/site/Navbar";
import ContactRail from "../components/site/ContactRail";
import PageHero from "../components/site/PageHero";
import DedicatedCTA from "../components/site/DedicatedCTA";
import { Problem, Positioning, Journey, Experience } from "../components/site/Sections1";
import { Build, System } from "../components/site/Sections2";
import { Founder, Why, NotPromise, Process } from "../components/site/Sections4";
import { Footer } from "../components/site/Sections5";

export default function About() {
  useLenis();
  const [data, setData] = useState(DEFAULT_SITE_DATA);

  useEffect(() => {
    publicApi.get("/site").then((r) => {
      if (r.data?.content) setData(r.data);
    }).catch(() => {});
  }, []);

  const c = data?.content || DEFAULT_SITE_DATA.content;

  return (
    <div className="bg-white min-h-screen flex flex-col" data-testid="about-page">
      <SEO
        title="About ADMALL INDIA | Integrated Advertising & Creative Agency"
        description="Discover ADMALL INDIA's integrated advertising model, multidisciplinary team, and vision from Navi Mumbai to enterprise scale."
        canonical="https://admallindia.com/about"
      />
      <Navbar logo={c.logo_url} />
      <ContactRail settings={c.settings} />

      <main className="flex-grow">
        <PageHero
          category="About ADMALL"
          categoryLink="/about"
          title="Connected Advertising & Commercial Growth"
          tagline="ADMALL INDIA was founded on a simple conviction: businesses don't need fragmented vendors—they need an accountable partner to build the brand, command attention, and drive sustained revenue."
          bgImage="https://images.unsplash.com/photo-1781127445273-0f1fdca3a9f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          ctaLabel="Discuss A Project"
          ctaHref="/contact"
        />

        <Positioning data={c.positioning} />
        <Problem data={c.problem} />
        <Journey data={c.journey} />
        <Experience data={c.experience} />
        <Build data={c.build} />
        <System data={c.system} />
        <Founder data={c.founder} />
        <Why data={c.why} />
        <NotPromise data={c.not_promise} />
        <Process data={c.process} />

        <DedicatedCTA
          title="Ready to build an enduring brand?"
          subtitle="Schedule a strategic discovery session with our leadership team in Navi Mumbai. No generic pitch decks, just honest commercial clarity."
          source="about_page"
        />
      </main>

      <Footer content={c} />
    </div>
  );
}
